export const STATUS_ITEMS = ['pending', 'approved', 'denied', 'canceled', 'completed'];

export const STATUS_COLORS = {
  pending: 'pending',
  approved: 'primary',
  denied: 'danger',
  canceled: 'warning',
  completed: 'success',
};

export const REQUEST_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  CANCELED: 'canceled',
  DENIED: 'denied',
  COMPLETED: 'completed',
};
